import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Link, navigate } from "@reach/router";
import Iframe from "react-iframe";

import {
  Title,
  Paragraph,
  SubTitle,
  DocImage,
  NavigateButton,
  DocPaper,
  DocLink,
  Panel,
  Text,
  TabWithContent,
  useDynamicImage
} from "../../../DocCreater";

const useStyles = makeStyles(theme => ({
  grid: {
    flexGrow: 1
  },
  stepperBar: {
    marginTop: theme.spacing(4)
  },
  divider: {
    width: "100%",
    height: 1
  },
  paper: {
    width: "100%"
  }
}));

const imageFolder = "/images/learnpage/step1/";

//林徽因请示营造则例绪论
const linhuiyin = (
  <div>
    <SubTitle>一、</SubTitle>
    <Paragraph>
      中国建筑为东方独立系统，数千年来，继承演变，流布极广大的区域。虽然在思想及生活上，中国曾多次受外来异族的影响，发生多少变异，而中国建筑直至成熟繁衍的后代，竟仍然保存着它固有的结构方法及布置规模；始终没有失掉它原始面目，形成一个极特殊，极长寿，极体面的建筑系统。故这统系建筑的特征，足以加以注意的，显然不单是其特殊的形式，而是产生这特殊形式的基本结构方法，和这结构法在这数千年中单纯顺序的演进。
    </Paragraph>
    <Paragraph>
      所谓原始面目，即是我国所有建筑，由民舍以至宫殿，均由若干单个独立的建筑物集合而成；而这单个建筑物，由最古代简陋的胎形，到最近代穷奢极巧的殿宇，均始终保留着三个基本要素：台基部分，柱梁或木造部分，及屋顶部分。
    </Paragraph>
    <Paragraph>
      在外形上，三者之中，最庄严美丽，迥然殊异于他系建筑，为中国建筑博得最大荣誉的，自是屋顶部分。但在技艺上，经过最艰巨的努力，最繁复的演变，登峰造极，在科学美学两层条件下最成功的，却是支承那屋顶的柱梁部分，也就是那全部木造的骨架。这全部木造的结构法，也便是研究中国建筑的关键所在。
    </Paragraph>
    <Paragraph>
      中国木造结构方法，最主要的就在构架（structural
      frame）之应用。北方有句通行的谚语，“墙倒房不塌”，正是这结构原则的一种表征。其用法则在构屋程序中，先用木材构成架子作为骨干，然后加上墙壁，如皮肉之附在骨上，负重部分全赖木架；毫不借重墙壁；所有门窗装修部分绝不受限制，可尽量充满木架下空隙，墙壁部分则可无限制的减少。这种结构法与欧洲古典派建筑的结构法，在演变的程序上，互异其倾向。
    </Paragraph>
    <Paragraph>
      中国木构正统一贯享了三千多年的寿命，仍还健在。希腊古代木构建筑则在纪元前十几世纪，已被石取代，由构架变成垒石，支重部分完全倚赖“荷重墙”（bearingwall）墙既荷重，墙上开辟门窗处，因能减损荷重力量，遂受极大限制；门窗与墙在同建筑中乃成冲突原素。
    </Paragraph>
    <Paragraph>
      在欧洲各派建筑中，除去最现代始盛行的钢架法，及铁筋水泥构架法外，惟有高矗式（Gothic）建筑，曾经用过构架原理；但高矗式仍是垒石发券（arch）作为构架，规模与单纯木架甚是不同。高矗式中又有所谓“半木构法”（halftimber）则与中国构架极相类似。惟因有垒石制影响之同时存在，此种半木构法之应用，始终未能如中国构架之彻底纯净。
    </Paragraph>
    <Paragraph>
      屋顶的特殊轮廓为中国建筑外形上显著的特征，屋檐支出的深远则又为其特点之一。
    </Paragraph>
    <Paragraph>
      为求这檐部的支出，用多层曲木承托，便在中国构架中发生了一个重要的斗栱部分；这斗栱本身的进展，且代表了中国各时代建筑演变的大部分历程。
    </Paragraph>
    <Paragraph>
      斗栱不惟是中国建筑独有的一个部分，而且在后来还成为中国建筑独有的一种制度。就我们所知，至迟自宋始，斗栱就有了一定的大小权衡；以斗栱之一部为全部建筑物权衡的基本单位，如宋式之“材”“契”与清式之“斗口”。
    </Paragraph>
    <Paragraph>
      这制度与欧洲文艺复兴以后以希腊罗马旧物作则所制定的order，以柱径之倍数或分数定建筑物各部一定的权衡（proportion），极相类似。所以这用斗栱的构架，实是中国建筑真髓所在。
    </Paragraph>
    <Paragraph>
      斗栱后来虽然变成构架中极复杂之一部，原始却甚简单，它的历史竟可以说与华夏文化同长。秦汉以前，在实物上，我们现在还没有发现有把握的材料，供我们研究，但在文献里，关于描写构架及斗栱的词句，则多不胜载：如臧文仲之“山节藻棁”，鲁灵光殿“层栌磥垝以岌峨，曲枅要绍而环句……”等。但单靠文人的辞句，没有实物的映证，由现代研究工作的眼光看去极感到不完满。
    </Paragraph>
    <Paragraph>
      没有实物我们是永没有法子真正认识，或证实，如“山节”“层栌”“曲枅”这些部分之为何物，但猜疑它们为木构上斗拱部分，则大概不会太谬误的。现在我们只能希望在最近的将来考古家实地挖掘工作里能有所发现，可以帮助我们更确实的了解。
    </Paragraph>
    <Paragraph>
      实物真正之有“建筑的”价值者，现在只能上达东汉。墓壁的浮雕画象中往往有建筑的图形；山东、四川、河南多处的墓阙，虽非真正的宫室，但是用石料摹仿木造的实物。早代木造建筑，因限于木料之不永久性，不能完整的存在到今日，所以供给我们研究的古代实物，多半是用石料明显的摹仿木造建筑物。且此例不单限于中国古代建筑。
    </Paragraph>
    <Paragraph>
      在这两种不同的石刻之中，构架上许多重要的基本部分，如柱，梁，额，屋顶，瓦饰等等，多已表现；斗栱更是显著，与二千年后的，在制度，权衡，大小上，虽有不同，但其基本的观念和形体，却是始终一贯的。
    </Paragraph>
    <Paragraph>
      在云冈，龙门，天龙山诸石窟，我们得见六朝遗物。其中天龙山石窟，尤为完善，石窟口凿成整个门廊；柱，额，斗拱，椽檐，瓦，样样齐全。这是当时木造建筑忠实的石型，由此我们可以看到当时斗栱之形制，和结构雄大，简单疏朗的特征。
    </Paragraph>
    <Paragraph>
      唐代给后人留下的实物最多是砖塔，垒砖之上又雕刻成木造部分，如柱，如阑额，斗栱。唐时木构建筑完整存在到今日，虽属可能，但在国内至今尚未发现过一个，所以我们常依赖唐人画壁里所描画的伽蓝，殿宇，来作各种参考。
    </Paragraph>
    <Paragraph>
      由西安大雁塔门楣上石刻——一幅惊人的清晰写真的描画——研究斗栱，知已较六朝更进一步。在柱头的斗栱上有两层向外伸出的翘，翘头上已有横栱厢栱。敦煌石窟中唐五代的画壁，用鲜明准确的色与线，表现出当时殿宇楼阁，凡是在建筑的外表上所看得见的结构，都极忠实的表现出来。
    </Paragraph>
    <Paragraph>
      斗栱虽是难于描画的部分，但在画里却清晰，可以看到规模。当时建筑的成熟实已可观。全个木造实物，国内虽尚未得见唐以前物，但在日本则有多处，尚巍然存在。其中著名的，如奈良法隆寺之金堂，五重塔，和中门，乃飞鸟时代物，适当隋代，而其建造者乃由高丽东渡的匠师。
    </Paragraph>
    <Paragraph>
      奈良唐招提寺的金堂及讲堂乃唐僧鉴真法师所立，建于天平时代，适为唐肃宗至德二年。这些都是隋唐时代中国建筑在远处得流传者，为现时研究中国建筑演变的极重要材料；尤其是唐招提寺的金堂，斗栱的结构与大雁塔石刻画中的斗栱结构，几完全符合——一方面证明大雁塔刻画之可靠，一方面又可以由这实物一探当时斗栱结构之内部。
    </Paragraph>
    <Paragraph>
      宋辽遗物甚多，即限于已经专家认识，摄影，或测绘过的各处来说，最古的已有距唐末仅数十年时的遗物。近来发现又重新刊行问世的李明仲《营造法式》一书，将北宋晚年“官式”建筑，详细的用图样说明，乃是罕中又罕的术书。于是宋代建筑蜕变的程序，步步分明。使我们对这上承汉唐，下启明清的关键，已有十分满意的把握。
    </Paragraph>
    <Paragraph>
      元明术书虽然没有存在的，但遗物可征者，现在还有很多，不难加以相当整理。清代于雍正十二年钦定公布《工程做法则例》，凡在北平的一切公私建筑，在京师以外许多的“敕建”建筑，都崇奉则例，不敢稍异。现在北平的故宫及无数庙宇，可供清代营造制度及方法之研究。优劣姑不论，其为我国几千年建筑的嫡嗣，则绝无可疑。
    </Paragraph>
    <Paragraph>
      不研究中国建筑则已，如果认真研究，则非对清代则例相当熟识不可。在年代上既不太远，术书遗物又最完全，先着手研究清代，是势所必然。有一近代建筑知识作根底，研究古代建筑时，在比较上便不至茫然无所依傍，所以研究清式则例，也是研究中国建筑史者所必须经过的第一步。
    </Paragraph>
    <SubTitle>二、</SubTitle>
    <Paragraph>
      以现代眼光，重新注意到中国建筑的一般人，虽尊崇中国建筑特殊外形的美丽，却常忽视其结构上之价值。这忽视的原因，常常由于笼统的对中国建筑存一种不满的成见。这不满的成见中最重要的成份，是觉到中国木造建筑之不能永久。其所以不能永久的主因，究为材料本身或是其构造法的简陋，却未尝深加探讨。
    </Paragraph>
    <Paragraph>
      中国建筑在平面上是离散的，若干座独立的建筑物，分配在院宇各方，所以虽然最主要雄伟的宫殿，若是以一座单独的结构，与欧洲任何全座负盛名的石造建筑物比较起来，显然小而简单，似有逊色。这个无形中也影响到近人对本国建筑的怀疑或蔑视。
    </Paragraph>
    <Paragraph>
      中国建筑既然有上述两特征；以木材作为主要结构材料，在平面上是离散的独立的单座建筑物，严格的，我们便不应以单座建筑作为单位，与欧美全座石造繁重的建筑物作任何比较。但是若以今日西洋建筑学和美学的眼光来观察中国建筑本身之所以如是，和其结构历来所本的原则，及其所取的途径，则这统系建筑的内容，的确是最经得起严酷的分析而无所惭愧的。
    </Paragraph>
    <Paragraph>
      我们知道一座完善的建筑，必须具有三个要素：适用，坚固，美观。但是这三个条件都不是有绝对的标准的。因为任何建筑皆不能脱离产生它的时代和环境来讲的；其实建筑本身常常是时代环境的写照。
    </Paragraph>
    <Paragraph>
      建筑里一定不可避免的，会反映着各时代的智识，技能，思想，制度，习惯，和各地方的地理气候。所以所谓适用者，只是适合于当时当地人民生活习惯气候环境而讲。
    </Paragraph>
    <Paragraph>
      所谓坚固，更不能脱离材料本质而论；建筑艺术是产生在极酷刻的物理限制之下，天然材料种类很多，不一定都凑巧的被人采用，被选择采用的材料，更不一定就是最坚固，最容易驾驭的。
    </Paragraph>
    <Paragraph>
      既被选用的材料，人们又常常习惯的继续将就它，到极长久的时间，虽然在另一方面，或者又引用其他材料，方法，在可能范围内来补救前者的不足。所以建筑艺术的进展，大部也就是人们选择，驾驭，征服天然材料的试验经过。
    </Paragraph>
    <Paragraph>
      所谓建筑的坚固，只是不违背其所用材料之合理的结构原则，运用通常智识技巧，使其在普通环境之下——兵火例外——能有相当永久的寿命的。例如石料本身比木料坚固，然在中国用木的方法竟达极高度的圆满，而用石的方法甚不妥当，且建筑上各种问题常不能独用石料解决，即有用石料处亦常发生弊病，反比木质的部分容易损毁。
    </Paragraph>
    <Paragraph>
      至于论建筑上的美，浅而易见的，当然是其轮廓，色彩，材质等，但美的大部分精神所在，却蕴于其权衡中；长与短之比，平面上各大小部分之分配，立体上各体积各部分之轻重均等，所谓增一分则太长，减一分则太短的玄妙。但建筑既是主要解决生活上实际各问题，而用材料所结构出来的物体，所以无论美的精神多缥渺难以捉摸，建筑上的美，是不能脱离合理的，有机能的，有作用的结构而独立。
    </Paragraph>
    <Paragraph>
      能呈现平稳，舒适，自然的外象；能诚实的袒露内部有机的结构，各部的功用，及全部的组织；不事掩饰；不矫揉造作；能自然的发挥其所用材料的本质的特性；只设施雕饰于必需的结构部分，以求更和悦的轮廓，更调谐的色彩；不勉强结构出多余的装饰物来增加华丽；不滥用曲线或色彩来求媚于庸俗；这些便是“建筑美”所包含的各条件。
    </Paragraph>
    <Paragraph>
      中国建筑，不容疑义的，曾经具备过以上所说的三个要素：适用，坚固，美观。在木料限制下经营结构“权衡俊美的”（beautifully
      proportioned），“坚固”的，各种建筑物，来适应当时当地的种种生活习惯的需求。
    </Paragraph>
    <Paragraph>
      我们只说其“曾经”具备过这三要素；因为中国现代生活种种与旧日积渐不同。所以旧制建筑的各种分配，随着便渐不适用。尤其是因政治制度，和社会组织忽然改革，迥然与先前不同；一方面许多建筑物完全失掉原来功用，——如宫殿，庙宇，官衙，城楼等等；——一方面又需要因新组织而产生的许多公共建筑——如学校，医院，工厂，驿站，图书馆，体育馆，博物馆，商场等等；——在适用一条下，现在既完全的换了新问题，旧的答案之不能适应，自是理之当然。
    </Paragraph>
    <Paragraph>
      中国建筑坚固问题，在木料本质的限制之下，实是成功的。下文分析里，更可证明其在技艺上，有过极艰巨的努力，而得到许多圆满，且可骄傲的成绩。如“梁架”，如“斗栱”，如“翼角翘起”种种结构做法及用材。直至最近代科学猛进，坚固标准骤然提高之后，木造建筑之不永久性，才令人感到不满意。但是近代新发明的科学材料，如钢架及钢骨水泥，作木石的更经济更永久的替代，其所应用的结构原则，却正与我们历来木造结构所本的原则符合。所以即使木料本身有遗憾，因木料所产生的中国结构制度的价值则仍然存在，且这制度的设施，将继续的应用在新材料上，效劳于我国将来的新建筑。这一点实在是值得注意的。
    </Paragraph>
    <Paragraph>
      已往建筑即使因人类生活状态之更换，致失去原来功用，其历史价值不论，其权衡俊秀或魁伟，结构灵活或诚朴，其纯美术的价值仍显然绝不能讳认的。古埃及的陵殿，希腊的神庙，中世纪的堡垒，文艺复兴中的宫苑，皆是建筑中的至宝，虽然其原始作用已全失去。虽然建筑的美术价值不会因原始作用失去而低减，但是这建筑的“美”却不能脱离适当的，有机的，有作用的结构，而独立的。
    </Paragraph>
    <Paragraph>
      中国建筑的美就是合于这原则；其轮廓的和谐，权衡的俊秀伟丽，大部分是有机，有用的，结构所直接产生的结果。并非因其有色彩，或因其形式特殊，我们推崇中国建筑；而是因产生这特殊式样的内部是智慧的组织，诚实的努力。中国木造构架中凡是梁，栋，檩，椽，及其承托，关联的结构部分，全都袒露无遗；或稍经修饰，或略加点缀，大小错杂，功用昭然。
    </Paragraph>
    <SubTitle>三、</SubTitle>
    <Paragraph>
      虽然中国建筑有如上述的好处，但在这三千年中，各时期差别很大，我们不能笼统的一律看待。大凡一种艺术的始期，都是简单的创造，直率的尝试；规模粗具之后，才节节进步使达完善，那时期的演变常是生气勃勃的。
    </Paragraph>
    <Paragraph>
      成熟期既达，必有相当时期因承相袭，规定则例，即使对前制有所更改，亦仅限于琐节。单在琐节上用心“过尤不及”的增繁弄巧，久而久之，原始骨干精神必至全然失掉，变成无意义的形式。中国建筑艺术在这一点上也不是例外，其演进和退化的现象极明显的，在各朝代的结构中，可以看得出来。
    </Paragraph>
    <Paragraph>
      唐以前的，我们没有实物作根据，但以我们所知道的早唐和宋初实物比较，其间显明的进步，使我们相信这时期必仍是生气勃勃，一日千里的时期。结构中含蕴早期的直率及魄力，而在技艺方面又渐精审成熟。
    </Paragraph>
    <Paragraph>
      以宋代头一百年实物和北宋末年所规定的则例（宋李明仲《营造法式》）比看，它们相差之处，恰恰又证实成熟期到达后，艺术的运命又难免趋向退化。但建筑物的建造不易，且需时日，它的寿命最短亦以数十年，半世纪计算。所以演进退化，也都比较和缓转折。所以由南宋而元而明而清八百余年间，结构上的变化，虽无疑的均趋向退步，但中间尚有起落的波澜，结构上各细部虽多已变成非结构的形式，用材方面虽已渐渐过当的不经济，大部骨干却仍保留着原始结构的功用，构架的精神尚挺秀健在。
    </Paragraph>
    <Paragraph>
      现在且将中国构架中大小结构各部作个简单的分析，再将几个部分的演变略为申述，裨研究清式则例的读者，稍识那些严格规定的大小部分的前身，且知分别何者为功用的，魁伟诚实的骨干，何者为功用部分之堕落，成为纤巧非结构的装饰物。即引用清式则例之时，若需酌量增减变换，亦可因稍知其本来功用而有所凭藉；或恢复其结构功用的重要，或矫正其纤细取巧之不适当者，或裁削其不智慧的奢侈的用材。在清制权衡上既知其然，亦可稍知其所以然。
    </Paragraph>
    <Paragraph>
      <b>构　架</b>
      木造构架所用的方法，是在四根立柱的上端，用两横梁两横枋周围牵制成一间。再在两梁之上架起层叠的梁架，以支桁；桁通一间之左右两端，从梁架顶上脊瓜柱上，逐级降落，至前后枋上为止。瓦坡曲线即由此而定。桁上钉椽，排比并列，以承望板；望板以上始铺瓦作，这是构架制骨干最简单的说法。这“间”所以是中国建筑的一个单位；每座建筑物都是由一间或多间合成的。
    </Paragraph>
    <Paragraph>这构架方法之影响至其外表式样的，有以下最明显的几点：</Paragraph>
    <Paragraph>
      （一）高度受木材长短之限制，绝不出木材可能的范围。假使有高至二层以上的建筑，则每层自成一构架，相叠构成，如希腊，罗马之superpesedorder。
    </Paragraph>
    <Paragraph>
      （二）即极庄严的建筑，也呈现绝对玲珑的外表。结构上无论建筑之大小，绝不需要坚厚的负重墙，除非故意为表现伟雄时，如城楼等建筑，酌量的增厚。
    </Paragraph>
    <Paragraph>
      （三）门窗大小可以不受限制；柱与柱之间可以全部安装透光线的小木作——门屏窗扇之类，使室内有充分的光线。不似垒石建筑门窗之为负重墙上的洞，门窗之大小与墙之坚弱是成反比例的。
    </Paragraph>
    <Paragraph>
      （四）层叠的梁架逐层增高，成“举架法”，使屋顶瓦坡，自然的，结构的，得一种特别的斜曲线。
    </Paragraph>
    <Paragraph>
      <b>斗　栱</b>
      　中国构架中最显著且独有的特征便是屋顶与立柱间过渡的斗栱。椽出为檐，檐承于檐桁上，为求檐伸出深远，故用重叠的曲木——翘——向外支出，以承挑檐桁。为求减少桁与翘相交处的剪力，故在翘头加横的曲木——栱。在栱之两端或栱与翘相交处，用斗形木块——斗——垫托于上下两层栱或翘之间。这多数曲木与斗形木块结合在一起，用以支撑伸出的檐者，谓之斗栱。
    </Paragraph>
    <Paragraph>
      这檐下斗栱的职务，是使房檐的重量渐次集中下来直到柱的上面。但斗栱亦不限于檐下，建筑物内部柱头上亦多用之，所以斗栱不分内外，实是横展结构与立柱间最重要的关节。
    </Paragraph>
    <Paragraph>
      在中国建筑演变中，斗栱的变化极为显著，竟能大部分的代表各时期建筑技艺的程度及趋向。
    </Paragraph>
    <Paragraph>
      最早的斗栱实物我们没有木造的，但由仿木造的汉石阙上看，这种斗栱，明显的较后代简单得多；由斗上伸出横栱，栱之两端承檐桁。不止我们不见向外支出的翘，即和清式最简单的“一斗三升”比较，中间的一升亦未型成，虽有，亦仅为一小斗介于栱之两端。
    </Paragraph>
    <Paragraph>
      直至北魏北齐如云冈天龙山石窟前门，始有斗栱像今日的一斗三升之制。唐大雁塔石刻门楣上所画斗栱，给与我们证据，唐时已有前面向外支出的翘宋称华栱，且是双层，上层托着横拱，然后承桁。关于唐代斗栱形状，我们所知道的，不只限于大雁塔石刻，鉴真所建奈良唐招提寺金堂，其斗栱结构与大雁塔石刻极相似，由此我们也稍知此种斗栱后尾的结束。进化的斗栱中最有机的部分，“昂”亦由这里初次得见。
    </Paragraph>
    <Paragraph>
      国内我们所知道最古的斗栱结构，则是思成前年在沛北蓟县所发现的独乐寺的观音阁，阁为北宋初年公元九八四物，其斗栱结构的雄伟，诚实，一望而知其为有功用有机能的组织。
    </Paragraph>
    <Paragraph>
      这个斗栱中两昂斜起，向外伸出特长，以支深远的出檐，后尾斜削挑承梁底，如是故这斗栱上有一种应力；以昂为横杆（lever），以大斗为支点，前檐为荷载，而使昂后尾下金桁上的重量下压维持其均衡（equilibrium）。斗栱成为一种有机的结构，可以负担屋顶的荷载。
    </Paragraph>
    <Paragraph>
      由建筑物外表之全部看来，独乐寺观音阁与敦煌的五代壁画极相似，连斗栱的构造及分布亦极相同。以此作最古斗栱之实例，向下跟着时代看斗拱演变的步骤，以至清代，我们可以看出一个一定的倾向，因而可以定清式斗栱在结构和美术上的地位。
    </Paragraph>
    <Paragraph>
      辽宋元明清斗拱比较，即可见其（一）由大而小，（二）由简而繁，（三）由雄壮而纤巧，（四）由结构的而装饰的，（五）由真结构的而成假刻的部分如昂部，（六）分布由疏朗而繁密。
    </Paragraph>
    <Paragraph>
      辽圣宗朝物，可以说是北宋初年的作品。其高度约占柱高之半至五分之二。斗栱出踩较多一踩，按《工程做法则例》的尺寸，则斗栱高只及柱高之四分之一。而辽清间的其他斗栱，年代逾后，则斗栱与柱高之比逾小。在比例上如此，实际尺寸上亦如此。于是后代的斗栱，日趋繁杂纤巧；斗栱的功用，日渐消失；如斗栱原为支檐之用，至清代则将挑檐桁放在梁头上，其支出远度无所赖于层层支出的曲木翘或昂。而辽宋斗栱，均为一种有机的结构，负责的承檐及屋顶的荷载。明清以后的斗栱，除在柱头上者尚有相当结构机能外，其平身科已成为半装饰品了。
    </Paragraph>
    <Paragraph>
      至于斗栱之分布，在唐画中及独乐寺所见，柱头与柱头之间，率只用补间斗栱清称平身科一朵攒；“营造法式”规定当心间用两朵，次梢间用一朵。至明清以斗口十一分定攒档，两柱之间，可以用到八攒平身科，密密的排列，不止全没有结构价值，本身反成为额枋上重累，比起宋建，雄壮豪劲相差太多了。
    </Paragraph>
    <Paragraph>
      梁架用材的力学问题，清式较古式及现代通用的结构法，都有个显著的大缺点。现代用木梁，多使梁高与宽作二与一或三与二之比，以求其最经济最得力的权衡。宋《营造法式》也规定为三与二之比。《工程做法则例》则定为十与八或十二与十之比，其断面近乎正方形，又是个不科学不经济的用材法。
    </Paragraph>
    <Paragraph>
      <b>屋　顶</b>{" "}
      历来被视为极特异极神秘之中国屋顶曲线，其实只是结构上直率自然的结果，并没有什么超出力学原则以外和矫揉造作之处，同时在实用及美观上皆异常的成功。这种屋顶全部的曲线及轮廓，上部巍然高耸，檐部如翼轻展，使本来极无趣，极笨拙的实际部分，成为整个建筑物美丽的冠冕，是别系建筑所没有的特征。
    </Paragraph>
    <Paragraph>
      因雨水和光线的切要实题，屋顶早就扩张出檐的部分。出檐远，檐沿则亦低压，阻碍光线，且雨水顺势急流，檐下亦发生溅水问题。为解决这两个问题，于是有飞檐的发明：用双层椽子，上层椽子微曲，使檐沿向上稍翻成曲线。到屋角时，更同时向左右抬高，使屋角之檐加甚其仰翻曲度。这“翼角翘起”，在结构上是极合理，极自然的布置，我们竟可以说：屋角的翘起是结构法所促成的。因为在屋角两檐相交处的那根主要构材——“角梁”及上段“由戗”——是较椽子大得很多的木材，其方向是与建筑物正面成四十五度的，所以那并排一列椽子，与建筑物正面成直角的，到了靠屋角处必须积渐开斜，使渐平行于角梁，并使最后一根直到紧贴在角梁旁边。但又因椽子同这角梁的大小悬殊，要使椽子上皮与角梁上皮平，以铺望板，则必须将这开舒的几根椽子依次抬高，在底下垫“枕头木”。凡此种种皆是结构上的问题适当的，被技巧解决了的。
    </Paragraph>
    <Paragraph>
      这道曲线在结构上几乎是不可信的简单和自然；而同时在美观上不知增加多少神韵。不过我们须注意过当或极端的倾向，常将本来自然合理的结构变成取巧和复杂。这过当的倾向，表面上且呈出脆弱虚矫的弱点，为审美者所不取。但一般人常以愈巧愈繁必是愈美，无形中多鼓励这种倾向。南方手艺灵活的地方，飞檐及翘角均特别过当，外观上虽有浪漫的姿态，容易引人赞美，但到底不及北方现代所常见的庄重恰当，合于审美的真纯条件。
    </Paragraph>
    <Paragraph>
      屋顶的曲线不只限于“翼角翘起”与“飞檐”，即瓦坡的全部，也是微曲的不是一片直的斜坡；这曲线之由来乃从梁架逐层加高而成，称为“举架”详第三章，使屋顶斜度越上越峻峭，越下越和缓。《考工记》：“轮人为盖，上欲尊而宇欲卑，上尊而宇卑，则吐水疾而溜远”，很明白的解释这种屋顶实际上的效用。在外观上又因这“上尊而宇卑”，可以矫正本来屋脊因透视而减低的倾向，使屋顶仍得巍然屹立，增加外表轮廓上的美。
    </Paragraph>
    <Paragraph>
      至于屋顶上许多装饰物，在结构上也有它们的功用，或是曾经有过功用的。诚实的来装饰一个结构部分，而不肯勉强的来掩蔽一个结构枢纽或关节，是中国建筑最长之处；在屋顶瓦饰上，这原则仍是适用的。脊瓦是两坡接缝处重要的保护者，值得相当的注重，所以有正脊垂脊等部之应用。又因其位置之重要，略异其大小，所以正脊比垂脊略大。正脊上的正吻和垂脊上的走兽等等，无疑的也曾是结构部分。
    </Paragraph>
    <Paragraph>
      我们虽然没有证据，但我们若假定正吻原是管着脊部木架及脊外瓦盖的一个总关键，也不算一种太离奇的幻想；虽然正吻形式的原始，据说是因为柏梁台灾后，方士说“南海有鱼虬，尾似鸱，激浪降雨”，所以做成鸱尾象，以厌火祥的。垂脊下半的走兽仙人，或是斜脊上钉头经过装饰以后的变形。每行瓦陇前头一块上面至今尚有盖钉头的钉帽，这钉头是防止瓦陇下溜的。
    </Paragraph>
    <Paragraph>
      垂脊上饰物本来必不如清式复杂，敦煌壁画里常见用两座“宝珠”，显然像木钉的上部略经雕饰的。垂兽在斜脊上段之末，正分划底下骨架里由戗与角梁的节段，使这个瓦脊上饰物，在结构方面又增一种意义，不纯出于偶然。
    </Paragraph>
    <Paragraph>
      <b>台　基</b>
      　台基在中国建筑里也是特别发达的一部，也有悠久的历史。《史记》里“尧之有天下也，堂高三尺”。汉有三阶之制，左磩右平；三阶就是基台，磩即台阶的踏道，平即御路。这台基部分如希腊建筑的台基一样，是建筑本身之一部，而不可脱离的。在普通建筑里，台基已是本身中之一部，而在宫殿庙宇中尤为重要。如北平故宫三殿，下有白石崇台三重，为三殿作基座，如汉之三阶。
    </Paragraph>
    <Paragraph>
      这正足以表示中国建筑历来在布局上也是费了精详的较量，用这舒展的基座，来托衬壮伟巍峨的宫殿。在这点上日本徒知摹仿中国建筑的上部，而不采用底下舒展的基座，致其建筑物常呈上重下轻之势。近时新建筑亦常有只注重摹仿旧式屋顶而摒弃底下基座的。所以那些多层的所谓仿宫殿式的崇楼华宇，许多是生硬的直出泥上，令人生不快之感。
    </Paragraph>
    <Paragraph>
      关于台基的演变，我不在此赘述，只提出一个最值得注意之点来以供读《清式则例》时参考。
    </Paragraph>
    <Paragraph>
      台基有两种：一种平削方整的，另一种上下加枭混，清式称须弥座台基。这须弥座台基就是台基而加雕饰者，唐时已有，见于壁画，宋式更有见于实物的，且详载于《营造法式》中。
    </Paragraph>
    <Paragraph>
      但清式须弥座台基与唐宋的比较有个大不相同处：清式称“束腰”的部分，介于上下枭混之间，是一条细窄长道，在前时却是较大的主要部分——可以说是整个台基的主体。所以唐宋的须弥座基一望而知是一座台基上下加雕饰者，而清式的上下枭混与束腰竟是不分宾主，使台基失掉主体而纯像雕纹，在外表上大减其原来雄厚力量。
    </Paragraph>
    <Paragraph>
      在这一点上我们便可以看出清式在雕饰方面加增华丽，反倒失掉主干精神，实是个不可讳认的事实。
    </Paragraph>
    <Paragraph>
      <b>色　彩</b>
      色彩在中国建筑上所占的位置，比在别式建筑中重要得多，所以也成为中国建筑主要特征之一。油漆涂在木料上本来为的是避免风日雨雪的侵蚀；因其色彩分配的得当，所以又兼收实用与美观上的长处，不能单以色彩作奇特繁杂之表现。
    </Paragraph>
    <Paragraph>
      中国建筑上色彩之分配，是非常慎重的。檐下阴影掩映部分，主要色彩多为“冷色”，如青蓝碧绿，略加金点。柱及墙壁则以丹赤为其主色，与檐下幽阴里冷色的彩画正相反其格调。有时庙宇的柱廊竟以黑色为主，与阶陛的白色相映衬。这种色彩的操纵可谓轻重得当，极含蓄的能事。我们建筑既为用彩色的，设使这些色彩竟滥用于建筑之全部，使上下耀目辉煌，势必鄙俗妖冶，乃至野蛮，无所谓美丽和谐或庄严了。
    </Paragraph>
    <Paragraph>
      琉璃于汉代自罽宾传入中国；用于屋顶当始于北魏，明清两代，应用尤广，这个由外国传来的宝贵建筑材料，更使中国建筑放一异彩。本来轮廓已极优美的屋宇，再加以琉璃色彩的宏丽，那建筑的冠冕便几无瑕疵可指。但在瓦色的分配上也是因为操纵得宜；尊重纯色的庄严，避免杂色的猥琐，才能如此成功。
    </Paragraph>
    <Paragraph>
      琉璃瓦即偶有用多色的例，亦只限于庭园小建筑物上面，且用色并不过滥，所砌花样亦能单简不奢。既用色彩又能俭约，实是我们建筑术中值得自豪的一点。
    </Paragraph>
    <Paragraph>
      <b>平　面</b>
      　关于中国建筑最后还有个极重要的讨论：那就是它的平面布置问题。但这个问题广大复杂，不包括于本绪论范围之内，现在不能涉及。不过有一点是研究清式则例者不可不知的，当在此略一提到。
    </Paragraph>
    <Paragraph>
      凡单独一座建筑物的平面布置，依照清《工部工程做法》所规定，虽其种类似乎众多不等，但到底是归纳到极呆板，极简单的定例。所有均以四柱牵制成一间的原则为主体的，所以每座建筑物中柱的分布是极规则的。但就我们所知道宋代单座遗物的平面看来，其布置非常活动，比起清式的单座平面自由得多了。宋遗物中虽多是庙宇，但其殿里供佛设座的地方，两旁供立罗汉的地方，每处不同。在同一殿中，柱之大小有几种不同的，正间梢间柱的数目地位亦均不同的。（参看中国营造学社各期《汇刊》辽宋遗物报告。）
    </Paragraph>
    <Paragraph>
      所以宋式不止上部结构如斗拱斜昂是有机的组织，即其平面亦为灵活有功用的布置。现代建筑在平面上需要极端的灵活变化，凡是试验采用中国旧式建筑改为现代用的建筑师们，更不能不稍稍知道清式以外的单座平面，以备参考。
    </Paragraph>
    <Paragraph>
      <b>工　程</b>
      　现在讲到中国旧的工程学，本是对于现代建筑师们无所补益的，并无研究的价值。只是其中有几种弱点，不妨举出供读者注意而已。
    </Paragraph>
    <Paragraph>
      （一）清代匠人对于木料，尤其是梁，往往用得太费。这点上文已讨论过。他们显然不明了横梁载重的力量只与梁高成正比例，而与梁宽的关系较小。所以梁的宽度，由近代工程学的眼光看来，往往嫌其太过。
    </Paragraph>
    <Paragraph>
      同时匠师对于梁的尺寸，因没有计算木力的方法，不得不尽量放大，用极高的安全率，以避免危险。结果不但是木料之大靡费，而且因梁本身重量太重，以致影响及于下部的坚固。
    </Paragraph>
    <Paragraph>
      （二）中国匠师素不用三角形。他们虽知道三角形是惟一不变动几何形，但对于这原则却极少应用。在清式构架中，上部既有过重的梁，又没有用三角形支撑的柱，所以清代的建筑，经过不甚长久的岁月，便有倾斜的危险。北平街上随处有这种已倾斜而用砖礅或木柱支撑的房子。
    </Paragraph>
    <Paragraph>
      （三）地基太浅是中国建筑的一个大病。普通则例规定是台明高之一半，下面垫几步灰土。这种做法很不彻底，尤其是在北方，地基若不刨到冰线以下，建筑物的安全方面，一定要发生问题。
    </Paragraph>
    <Paragraph>
      好在这几个缺点，在新建筑师手里，根本就不成问题。我们只怕不了解，了解之后，去避免或纠正它是很容易的。
    </Paragraph>
    <Paragraph>
      上文已说到艺术有勃起，呆滞，衰落，各种时期，就中国建筑讲，宋代已是规定则例的时期，留下《营造法式》一书；明代的《营造正式》虽未发现，清代的《工程做法则例》却极完整。所以就我们所确知的则例，已有将近千年的根基了。这九百多年之间，建筑的气魄和结构之直率，的确一代不如一代，但是我认为还在抄袭时期；原始精神尚大部保存，未能说是堕落。
    </Paragraph>
    <Paragraph>
      可巧在这时间，有新材料新方法在欧美产生，其基本原则适与中国几千年来的构架制同一学理。而现代工厂，学校，医院，及其他需要光线和空气的建筑，其墙壁门窗之配置，其铁筋混凝土及钢骨的构架，除去材料不同外，基本方法与中国固有的方法是相同的。这正是中国老建筑产生新生命的时期。在这时期，中国的新建筑师对于他祖先留下的一份产业实在应当有个充分的认识。因此思成将他所已知道的比较详尽的清式则例整理出来，以供建筑师们和建筑学生们的参考。
    </Paragraph>
    <Paragraph>
      他嘱我为作绪论，申述中国建筑之沿革，并略论其优劣，我对于中国建筑沿革所识几微，优劣的评论，更非所敢。姑草此数千言，拉杂成此一篇，只怕对《清式则例》读者无所裨益但乱听闻。不过我敢对读者提醒一声：规矩只是匠人的引导，创造的建筑师们和建筑学生们，虽须要明了过去的传统规矩，却不要盲从则例，束缚自己的创造力。我们要记着一句普通谚语：“尽信书不如无书。”
    </Paragraph>
    <Paragraph>二十三年，一月，林徽因。</Paragraph>
  </div>
);

//实验前言
const IntroPanel = props => {
  const [docImageSrc2, setDocImageSrc2] = useDynamicImage(
    `${imageFolder}06-2.png`
  );
  const onlineSupportRoot = "http://qgssupport.pkugujian.com/";

  return (
    <TabWithContent
      content={[
        {
          title: "实验简介",
          detail: (
            <>
              <Paragraph>
                清官式大木作教学的主要内容分为四部分，分别为构件认知教学、清官式建筑构造教学、古建筑现场认知踏查、营造文献阅读与整理。本实验项目从教学内容出发，针对传统教学中面临的教学资源直观性差、实物模型数量少精度低学术性差无法满足搭建需求、现场踏查成本高有风险等教学痛点，设计了本实验项目，包含如下几个模块：
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}structure.jpg`} />
              <Paragraph>
                <Text color="secondary">构件认知学习模块:</Text>
                提供基本的构件信息学习，可供学生自主学习各个构件，掌握清官式大木作基础知识；学生首先通过本模块学习各类清官式大木作构件的名称、位置、描述等基础信息，查看构件的图纸、照片、重要营造文献中对构件的记载，掌握清官式大木作的基础知识；并通过构件辨识实验检验自身学习成果，不断巩固基础知识。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">实景学习模块:</Text>
                实景教学资源多为在典型的清代官式建筑现场采集的实景内容，例如建筑实地全景漫游，学生即可通过互联网在线查看建筑实景情况，以便学生通过真实建筑实物中进一步认知在清官式建筑中的各类构件的位置样式，与构件认知学习模块的理论部分相辅相成，同时为后续建筑现场踏查实习做好准备，虚实结合。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">虚拟搭建模块:</Text>
                虚拟搭建模块：选取清雍正十二年（1734年）清朝工部颁布的《工程做法》中建筑、斗栱样例作为虚拟搭建对象，并参考梁思成先生《清式营造则例》、《清工部〈工程做法〉图解》等书，通过三维建模软件，制作高仿真度的模型，严谨地再现清代官式大木建筑的风貌。实验包括平身科与歇山大木虚拟搭建两个搭建场景，通过这两个搭建场景，可以囊括清官式大木作的绝大部分构件与知识点；共包括平身科搭建实验、柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验五个子实验，每个部分均提供测试模式、教学模式、查看模式，方便学生自主学习、自主测试；学生在对构件基础知识熟练掌握的基础上，进一步通过此模块的学习，动手实践一整座清代官式建筑大木作部分的完整建造过程，最终熟练掌握清代官式建筑构造。
              </Paragraph>

              <Paragraph>
                依托以上三个模块，本项目提供六个可供交互操作的实验，包括构件辨识实验、平身科搭建实验、柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验；
              </Paragraph>
              <Paragraph>
                <Text color="secondary">清官式大木作教学资源库:</Text>
                教学资源库是整个实验项目的数据支撑，资源库设计架构如下图，学生在熟练掌握清官式大木作基础知识与建筑构造后，即可通过自主踏查文物建筑拍摄建筑构件照片、阅读清官式营造文献整理文献内容，将研究学习的成果在线加入教学资源库，提升学生自主学习研究积极性，同时保障教学资源库的持续建设。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}ziyuanku.jpg`} />
              <Paragraph>
                通过点击上方导航栏的"构件认知"、"实景学习"、"虚拟搭建"，访问实验的
                <DocLink to="/info/goujians">构件认知学习模块</DocLink>、
                <DocLink to="/realitylearn">实景学习模块</DocLink>、
                <DocLink to="/virtuallearn">虚拟搭建实验</DocLink>三个模块
                ，通过点击上方各步骤按钮，了解各模块使用详细操作引导
              </Paragraph>

              <Paragraph>
                <Text color="secondary">教学咨询服务:</Text>
                使用中有任何问题与意见，请点击
                <DocLink to="/">首页</DocLink>
                右下角在线咨询按钮，前往我们的在线教学支持服务页面，通过
                <DocLink to={onlineSupportRoot} newpage>
                  在线咨询
                </DocLink>
                或
                <DocLink to={`${onlineSupportRoot}/feedback/`} newpage>
                  邮件留言
                </DocLink>
                获取服务支持。
              </Paragraph>
            </>
          )
        },

        {
          title: "实验知识点",
          detail: (
            <>
              <Text color="secondary">实验知识点如下:</Text>

              <Paragraph>
                （1）
                清官式大木作各个构件名称、位置、权衡、功能(包括柱、梁、额枋、枋、斗栱、椽望、歇山各部等构件)
              </Paragraph>

              <Paragraph>
                （2）
                了解清官式大木作构件的样式及重要文献中的描述(包括构件照片图纸、构件在《清式营造则例》《清工部工程做法》《营造算例》中的记载与描述)
              </Paragraph>
              <Paragraph>
                （3） 清官式斗栱的构造方式；(平身科搭建实验，包括构件43个)
              </Paragraph>
              <Paragraph>
                （4）
                清官式建筑大木作整体的构造方式；(包括柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验，共计构件610个)
              </Paragraph>
              <Paragraph>
                （5）
                现场认知清官式建筑大木作各部分构件并记录；(包括在实景学习模块中进行虚拟建筑考古踏查，认知各个构件在真实建筑中的表现形式、并且拍照记录，将记录成果录入教学资源库)
              </Paragraph>
              <Paragraph>
                （6）
                营造文献的阅读与整理；(掌握了清官式大木作其他知识点后，阅读与清代建筑营造相关的文献，并将阅读文献后整理出的成果按构件分类录入教学资源库)
              </Paragraph>
            </>
          )
        },
        {
          title: "实验成绩",
          detail: (
            <>
              <Paragraph>
                实验成绩将显示在我的成绩页面，学生可点击页面右上角菜单中我的成绩，进入此页面
              </Paragraph>
              <DocImage imageSrc={docImageSrc2} />
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}06-2.png`);
                }}
              >
                <Text color="secondary">各实验成绩分布图:</Text>
                学生可查看个人最高分、最低分、全体平均分，教师可查看全体学生最高分、最低分、平均分
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}06-3.png`);
                }}
              >
                <Text color="secondary">实验完成次数饼图:</Text>
                学生可查看个人对各个实验的完成情况，教师可查看全体学生的实验完成情况
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}06-4.png`);
                }}
              >
                <Text color="secondary">实验详情表:</Text>
                学生可查看个人每次实验完成的详细情况，教师可查看全体学生所有实验完成情况数据，并且可以进行筛选过滤
              </Paragraph>
              <Paragraph
                onMouseOver={() => {
                  setDocImageSrc2(`${imageFolder}06-5.png`);
                }}
              >
                <Text color="secondary">构件辨识实验试卷详情:</Text>
                点击查看试卷按钮，可查看每次构件辨识实验的详细试卷情况
              </Paragraph>
            </>
          )
        }
      ]}
    />
  );
};

//实验流程与步骤
const StepPanel = props => {
  const [docImageSrc2, setDocImageSrc2] = useDynamicImage(
    `${imageFolder}06-2.png`
  );
  const onlineSupportRoot = "http://qgssupport.pkugujian.com/";

  return (
    <TabWithContent
      content={[
        {
          title: "实验流程",
          detail: (
            <>
              <Paragraph>
                本实验项目共分为三个模块：构件认知学习模块、实景学习模块、虚拟搭建模块三个模块，提供六个可交互操作的实验，包括构件辨识实验、平身科搭建实验、柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验，同时支撑实验的教学资源数据库，面向学生开放录入权限，可由学生持续录入建设。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}steps.jpg`} />

              <Paragraph>
                学生打开实验项目网站，登录验证后，即可进行各个模块的学习，首先学生应当通过导航栏上“学习流程”页面，阅读了解整个清官式大木作的流程，阅读前言部分《清式营造则例》序言，做好基础知识准备，同时阅读其他模块的交互式学习引导说明，了解各实验模块具体包含的内容。
              </Paragraph>
              <Paragraph>
                完成准备工作后，即可进入构件认知学习模块，学习构件的基础知识，学习过程中，可通过检索分类功能按类学习构件，相互比对学习；进入每个构件的详情页面，学习关于该构件更详细的信息；在学习到一定阶段时，可以反复使用本模块的构件辨识实验，测试并巩固学习效果。
              </Paragraph>
              <Paragraph>
                完成构件认知学习后，学生进入实景学习模块，阅读各个实景教学资源的说明、所属建筑、该资源的操作说明后，查看该实景学习资源的内容；利用上个模块中学习的理论知识结合实物建筑，虚实结合，巩固复习，锻炼观察认知实物建筑的能力；也可扫描实景学习资源二维码，使用移动设备学习。
              </Paragraph>
              <Paragraph>
                基础知识巩固后，进入虚拟搭建实验，进行平身科的搭建学习，先通过查看模式了解各个构件在平身科上的位置，深化理解；再通过教学模式，学习平身科如何搭建组合起来，最后进入测试模式，动手实践完成整个平身科的搭建。平身科搭建实验完成后，进入歇山大木搭建实验，通过查看模式、教学模式自主学习，最后分别完成柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验的测试模式。
              </Paragraph>
              <Paragraph>
                熟练掌握基础知识后，配合课堂教学开展的田野踏查实习，现场考察清官式建筑，根据所学理论知识，记录建筑上所见构件；并在教师指导下，阅读清官式营造文献，整理文献中与大木作构件有关的条文；最终将记录与整理成果录入实验项目教学资源库，完成整个教学流程的闭环；
              </Paragraph>
            </>
          )
        },
        {
          title: "实验交互步骤",
          detail: (
            <>
              <Text color="secondary">背景知识学习</Text>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou1.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤1:</Text>
                学生点击导航栏“学习流程”栏目，进入学习流程页面，查看学习流程的5个部分内容，首先阅读前言中的绪论，掌握基础的建筑史背景知识，随后阅读另外四个模块的教学引导，了解各模块内容与学习方法；
              </Paragraph>

              <Text color="secondary">构件认知学习模块</Text>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou2.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤2:</Text>
                学生点击导航栏“构件认知”栏目，默认进入子栏目“构件列表”，进入构件认知模块；依次查看构件认知模块中每个构件的卡片，点击卡片上图片查看详细图纸，切换位置图与透视图，了解构件样式与位置，阅读构件描述，点击3D按钮，查看构件3D模型；同时通过构件名称过滤、构件描述过滤、构件类型过滤检索功能辅助自身学习；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou3-1.jpg`} />
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou3-2.jpg`} />

              <Paragraph>
                <Text color="secondary">步骤3:</Text>
                点击本页面上方子栏目“参考文献”、“构件条文”，了解相关的清官式重要营造文献与专著，并可阅读原书PDF。参考文献与构件条文均可进行过滤查询，以便检索学习；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou4.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤4:</Text>
                点击每个卡片右上角详情按钮，进入单个构件详情页面，查看构件的详细信息，查阅构件图纸照片高清图、阅读构件在《清式营造则例》、《营造算例》、《工程做法》等重要文献中的记载与阐述，进一步深入学习各个构件的相关知识；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou5.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤5:</Text>
                点击本页面上方子栏目“辨识实验”，进入构件辨识实验，实验随机选取20个构件，通过透视图、位置图、3D模型考察学生对于构件的掌握程度，学生完成做答后，点击提交全部按钮，可查看作答正误情况，正误情况显示之后，作答卡片恢复交互状态，可直接用于学习并查看构件详情；
              </Paragraph>
              <Text color="secondary">实景学习模块</Text>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou6.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤6:</Text>
                学生点击导航栏“实景学习”栏目，进入实景学习模块，在各个实景学习模块卡片中，查看本实景资源所属的建筑实物、资源描述、资源操作方式信息，点击右下角按钮，展开实景教学资源，在资源窗口内点击全屏按钮，进行全屏模式学习获取最佳体验；实景教学资源以建筑现场实景漫游为主，可在漫游内，旋转缩放视角，切换视点，查看构件标签；实景学习资源提供扫描查看功能，学生点击右上角分享按钮，扫描弹出二维码，即可用手机查看实景学习资源，使用手机查看全景漫游类资源时，可以配合VR眼镜盒子，使用VR模式身临其境查看建筑实物；
              </Paragraph>

              <Text color="secondary">虚拟搭建模块</Text>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou7-1.jpg`} />
              <Paragraph>
                学生点击导航栏“虚拟搭建”栏目，进入虚拟搭建模块，本模块实验较大，请耐心等待资源加载，可开启浏览器缓存，方便下次使用使减少加载时间，实验提供平身科与歇山大木两个搭建场景，3D场景内均使用鼠标右键移动视角、滚轮滑动缩放、按住滚轮平移。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou7-2.jpg`} />
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou7-3.jpg`} />

              <Paragraph>
                <Text color="secondary">步骤7:</Text>
                选择平身科搭建场景，点击模型查看模式，在查看模式内，点击右侧面板对应的构件名称，实物中相应的构件会标红显示，点击相应的构件，则面板内构件名称会标红显示，同时场景左上角显示构件描述；点击右上方图标，可快速切换三视图查看模型，点击灯光按钮，为暗处补光，方便查看暗部构件；利用此模式交互式的学习平身科构造；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou8.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤8:</Text>
                在平身科搭建场景，选择教学模式，点击右侧工坊内构件，即可生成相应构件，使用鼠标拖动或键盘WASDQE操作构件移动，使用空格按钮或左侧面板箭头切换构件方向位置，逐层进行平身科的组装，构件成功安装后，会显示反馈信息；教学模式中可实时查看各个构件在模型中的位置，可使用左侧菜单查看提示信息，获得帮助并快速搭建；通过本步骤，学生可在有指导的情况下，完成平身科搭建，深入学习平身科构造；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou9.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤9:</Text>
                使用测试模式，对自身学习成果进行测试，独立完成平身科的搭建实验，并获得成绩记录，搭建交互操作方法与步骤8相同，但是无法使用教学模式中的提示引导功能，右侧面板会记录学生剩余需要安装的构件数量与测试时间，完成平身科搭建后会将此次测试成绩发送至服务器，未完成实验不记录成绩；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou10.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤10:</Text>
                完成平身科搭建实验后，选择歇山大木搭建场景，选择模型查看模式，在查看模式内，点击右侧面板对应的构件名称，实物中相应的构件会标红显示，点击相应的构件，则面板内构件名称会标红显示，同时场景左上角显示构件描述；点击右上方图标，可快速切换三视图查看模型，点击灯光按钮，为暗处补光，方便查看暗部构件；利用此模式交互式的学习歇山大木构架的组合搭建方式；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou11-1.jpg`} />
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou11-2.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤11:</Text>
                在歇山大木搭建场景，选择教学模式，点击右侧工坊内构件，即可生成相应构件，使用鼠标拖动或键盘WASDQE操作构件移动，使用空格按钮或左侧面板箭头切换构件方向位置，进行歇山大木的组装，构件成功安装后，会显示反馈信息；教学模式中可实时查看各个构件在模型中的位置，可使用左侧菜单查看提示信息，获得帮助并快速搭建；通过本步骤，学生可在有指导的情况下，完成歇山大木的搭建，深入学习完整的歇山大木作构造；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou12.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤12:</Text>
                使用测试模式，按顺序完成柱额层、斗栱层、屋架层、椽望层四个搭建测试实验，独立完成四个部分的搭建，并获得成绩记录，搭建交互操作与步骤11相同，但是无法使用教学模式中的提示引导功能，右侧面板会记录学生剩余需要安装的构件数量与测试时间，完成各层搭建实验后会将此次测试成绩发送至服务器，未完成实验不记录成绩；
              </Paragraph>

              <Text color="secondary">建设教学资源库（可选）</Text>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou13-1.jpg`} />
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou13-2.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤13:</Text>
                点击导航栏“构件认知”栏目，进入构件详情，可以看到构件图纸照片、构件条文栏目中的“+”按钮，点击即可弹出表单，填写表单字段即可向数据库内加入该构件的图纸照片及条文；学生应当在以上步骤操作完毕，对于清官式大木作基础知识牢固掌握的前提下，配合课程田野踏查实习，在实地考察时记录建筑细节照片，通过自主研读清式营造文献，摘录整理条文；最终在教师指导下将资源录入实验项目教学资源库，从实验项目的使用者转变为实验项目资源的建设者。
              </Paragraph>
            </>
          )
        }
      ]}
    />
  );
};

//介绍视频
const IntroVideo = props => {
  const { videoUrl } = props;
  return (
    <div
      style={{
        display: "block",
        height: "43.2vw",
        width: "76.8vw",
        overflow: "hidden",
        margin: "auto"
      }}
    >
      <Iframe url={videoUrl} width="100%" height="100%" allowFullScreen />
    </div>
  );
};

function Step1(props) {
  const classes = useStyles();
  return (
    <DocPaper>
      <Title>实验前言与预备知识</Title>
      <Panel
        panelTitle={<Text color="primary">实验前言 </Text>}
        panelDetail={<IntroPanel />}
        defaultOpen
      />
      <Panel
        panelTitle={<Text color="primary">实验流程与步骤 </Text>}
        panelDetail={<StepPanel />}
        defaultOpen
      />

      <Panel
        panelTitle={<Text color="primary">实验引导视频</Text>}
        panelDetail={<IntroVideo videoUrl="/videos/6min.mp4" />}
      />

      <Panel
        panelTitle={
          <Text color="primary">基础知识阅读 《清式营造则例》绪论</Text>
        }
        panelDetail={linhuiyin}
      />
      <NavigateButton
        icon
        to="/learn/step/2"
        buttonText="下一步"
        iconStyle={{
          float: "right"
        }}
      />
    </DocPaper>
  );
}

export default Step1;
